import React from "react";
import "./Meet_our_team_card.css";
import Play_button from "../../../animation/play_button/Play_button";

function Meet_our_team_card({ vdo_Src, headingText, desc_text, description }) {
  return (
    <>
      <section className="Meet_our_team_card ">
        <div className="play_vdo_section_holder">
          <div className="img_holder">
            {/* <img src={img_Src} alt="procces img" className="procces_img" /> */}
            <video className="procces_img" playsInline controls >
              <source src={vdo_Src} type="video/mp4" />
            </video>
          </div>
          <div className="play_btn_holder">
            {/* <Play_button /> */}
          </div>
        </div>
        <div className="text_holder">
          <h4>{headingText}</h4>
          <p>{desc_text}</p>
          <p>{description}</p>
        </div>
      </section>
    </>
  );
}

export default Meet_our_team_card;
